(function () {
  "use strict";

  class CareerMv {
    constructor(wrap) {
      this.wrap = wrap;

      this.wrap.querySelectorAll(".page-career__mv__nav li").forEach((li) => {
        const cn = li.className;
        const link = li.querySelector("a");
        link.addEventListener("mouseenter", () => {
          //console.log('mouseenter', cn);
          this.wrap.classList.add("is-hover");
          this.wrap.classList.add(`is-hover--${cn}`);
        });
        link.addEventListener("mouseleave", () => {
          //console.log('mouseleave', cn);
          this.wrap.classList.remove("is-hover");
          this.wrap.classList.remove(`is-hover--${cn}`);
        });
      });
    }
  }

  document.querySelectorAll(".page-career__mv").forEach((mv) => {
    new CareerMv(mv);
  });
})();
